import { useTranslation } from 'services/i18n'

import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'
import { cn } from 'utils/cn'

import type { FC } from 'react'

type Props = {
  capacityUsage: AttachmentWithUploadStatus['capacityUsage']
  contentType: AttachmentWithUploadStatus['contentType']
  errorType?: AttachmentWithUploadStatus['errorType']
  filename: string
  isDetailedView?: boolean
  isPending?: boolean
}

export const AttachmentInfo: FC<Props> = ({ capacityUsage, filename, errorType, isDetailedView, isPending }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'file_upload',
  })

  return (
    <div className="flex-col">
      <div className={cn('text-sm font-medium', {
        'text-subdued font-normal': isPending,
        'max-w-28 truncate mr-2': !isDetailedView,
        'break-all': isDetailedView,
      })}
      >
        {filename}
      </div>
      {isDetailedView && (
        <div className="text-sm text-subdued">
          <div className="flex gap-x-1">

            <span>
              {!!capacityUsage && (
                t('capacity_usage', { space: Math.round(capacityUsage * 100) })
              )}
            </span>
          </div>
          <div>
            {errorType && t(`error.${errorType}`, { defaultValue: t('error.upload_error') })}
          </div>

        </div>
      )}
    </div>
  )
}
